export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4638.f8088dda.jpg";